import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { QuickFiltersService } from '../../../@core/utils';
import { SpreadsheetColumnsService } from './../../../@core/utils/spreadsheet-columns.service';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-table-filter',
    templateUrl: './table-filter.component.html',
    styleUrls: ['./table-filter.component.scss'],
    standalone: true,
    imports: [TranslateModule],
})
export class TableFilterComponent implements OnInit, OnDestroy {
  @Input() public filtersNb: number;
  @Input() public tableType: 'asset' | 'invest' | 'initiative' | 'project' | 'site' | 'asset-types';
  public columnsDisplayed: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private spreadsheetColumnsService: SpreadsheetColumnsService,
    private quickFiltersService: QuickFiltersService,
  ) { }

  public ngOnInit(): void {
    let filterObs: BehaviorSubject<boolean>;
    switch (this.tableType) {
      case 'invest':
        filterObs = this.spreadsheetColumnsService._openInvestFilters;
        break;
      case 'asset':
        filterObs = this.spreadsheetColumnsService._openAssetFilters;
        this.quickFiltersService.removeDefaultFilter('asset');
        break;
      case 'initiative':
        filterObs = this.spreadsheetColumnsService._openInitiativeFilters;
        break;
      case 'project':
        filterObs = this.spreadsheetColumnsService._openProjectFilters;
        break;
      case 'site':
        filterObs = this.spreadsheetColumnsService._openSiteFilters;
        break;
      case 'asset-types':
        filterObs = this.spreadsheetColumnsService._openAssetTypesFilters;
        break;
    }
    this.subscriptions.push(
      filterObs.subscribe((value) => this.columnsDisplayed = value),
    );
  }

  public deleteFilters(): void {
    if (this.filtersNb > 0) {
      switch (this.tableType) {
        case 'invest':
          this.spreadsheetColumnsService._deleteInvestFilters.next(true);
          this.quickFiltersService.removeDefaultFilter('investment');
          break;
        case 'asset':
          this.spreadsheetColumnsService._deleteAssetFilters.next(true);
          this.quickFiltersService.removeDefaultFilter('asset');
          break;
        case 'initiative':
          this.spreadsheetColumnsService._deleteInitiativeFilters.next(true);
          break;
        case 'project':
          this.spreadsheetColumnsService._deleteProjectFilters.next(true);
          break;
        case 'site':
          this.spreadsheetColumnsService._deleteSiteFilters.next(true);
          break;
        case 'asset-types':
          this.spreadsheetColumnsService._deleteAssetTypesFilters.next(true);
          break;
      }
    }
  }

  public toggleFilters(): void {
    this.columnsDisplayed = !this.columnsDisplayed;
    switch (this.tableType) {
      case 'invest':
        this.spreadsheetColumnsService._openInvestFilters.next(this.columnsDisplayed);
        break;
      case 'asset':
        this.spreadsheetColumnsService._openAssetFilters.next(this.columnsDisplayed);
        break;
      case 'initiative':
        this.spreadsheetColumnsService._openInitiativeFilters.next(this.columnsDisplayed);
        break;
      case 'project':
        this.spreadsheetColumnsService._openProjectFilters.next(this.columnsDisplayed);
        break;
      case 'site':
        this.spreadsheetColumnsService._openSiteFilters.next(this.columnsDisplayed);
        break;
      case 'asset-types':
        this.spreadsheetColumnsService._openAssetTypesFilters.next(this.columnsDisplayed);
        break;
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
